import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=e08a7b16&scoped=true"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"
import style0 from "./serviceAgreement.vue?vue&type=style&index=0&id=e08a7b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a7b16",
  null
  
)

export default component.exports